/**
 * Single source of truth for portfolio projects (Projects page + Resume).
 * Image paths are relative to `public/`.
 */
export const portfolioProjects = [
  {
    id: 7,
    title: "RollPlan",
    description:
      "Full-stack gym SaaS for Brazilian Jiu-Jitsu: coach tools + member portal, curriculum and scheduling, JWT auth, Postgres. React, TypeScript, Express, optional Gemini.",
    longDescription:
      "Live at https://rollplan.app. Monorepo with split coach and member apps—rosters, classes, invites, QR check-ins, competition lists. No in-app payments. Details, API surface, and setup are in the README on GitHub.",
    image: "/assets/rollplan.png",
    categories: ["web", "featured", "ai"],
    liveLink: "https://rollplan.app",
    githubLink: "https://github.com/PkTaz/RollPlan",
    technologies: [
      "React",
      "TypeScript",
      "Vite",
      "Tailwind CSS",
      "React Router",
      "Express",
      "Node.js",
      "PostgreSQL",
      "Zod",
      "Resend",
      "Google Gemini",
    ],
  },
  {
    id: 2,
    title: "Color Pal",
    description:
      "An intelligent color palette generator that uses Claude AI to create harmonious color schemes based on natural language descriptions.",
    longDescription:
      "Color Pal leverages the power of AI to generate perfect color palettes for brands based on textual descriptions. The system analyzes tone, industry standards, and psychological aspects of colors to create visually appealing palettes.",
    image: "/assets/CPal.png",
    categories: ["ai", "design"],
    liveLink: "#",
    githubLink: "https://github.com/PkTaz/color-palette-ai",
    technologies: ["React", "Node.js", "Claude AI API", "CSS"],
  },
  {
    id: 1,
    title: "New Hue Design Restoration",
    description:
      "Built a full-stack responsive website utilizing the MERN stack to help bring more clients to a local business.",
    longDescription:
      "This project features a modern design with smooth animations, customer testimonials, and a robust appointment scheduling system. Built with React, Express, MongoDB, and Node.js.",
    image: "/assets/project1.png",
    categories: ["web", "featured"],
    liveLink: "https://new-hue-restoration-and-design-revamp.netlify.app/",
    githubLink: "https://github.com/PkTaz",
    technologies: ["React", "CSS", "Node.js", "Express", "MongoDB", "Netlify"],
  },
  {
    id: 6,
    title: "Gymshark Website Redesign",
    description:
      "A reimagined e-commerce experience for Gymshark with enhanced product displays, user journey optimization, and interactive fitness content.",
    longDescription:
      "This Gymshark redesign combines sleek aesthetics with powerful e-commerce functionality. Features include personalized product recommendations, size guide visualizations, workout plan integration, and a streamlined checkout process to improve conversion rates.",
    image: "/assets/gymshark.jpg",
    categories: ["web", "design", "featured"],
    liveLink: "https://gymshark-redesign.netlify.app/",
    githubLink: "#",
    technologies: ["React", "JavaScript", "CSS"],
  },
  {
    id: 5,
    title: "Detroit Lions Website Redesign",
    description:
      "A complete overhaul of the Detroit Lions website with a modern, fan-focused approach emphasizing team history and player profiles.",
    longDescription:
      "This redesign project focused on creating an immersive experience for Detroit Lions fans with interactive game schedules, player stats, team history, and ticketing features. The UI includes team colors and dynamic content that updates with real-time game information.",
    image: "/assets/lions.png",
    categories: ["web", "design", "featured"],
    liveLink: "https://detroit-lions-redesign.netlify.app/",
    githubLink: "https://github.com/PkTaz/detroit-lions-website",
    technologies: ["React", "TypeScript", "Framer", "TailwindCSS"],
  },
  {
    id: 3,
    title: "CRM Redesign",
    description:
      "Scalable CRM proposal for a logistics company—500 concurrent users, 2,000 daily interactions, and MS Exchange integration.",
    longDescription:
      "Proposed in response to a 42% sales increase: ticketing and calendar systems synced with MS Exchange via API, with AWS Lambda, S3, Amazon RDS, and Amazon Quicksight in the design.",
    image: "/assets/project2.jpg",
    categories: ["web", "featured"],
    liveLink:
      "https://docs.google.com/document/d/19SlGq47Lvz6FjakNmUhr8yz57Cz8VCHI/edit?usp=sharing&ouid=115633295017463972231&rtpof=true&sd=true",
    githubLink: "#",
    technologies: ["AWS Lambda", "S3", "Amazon RDS", "Amazon Quicksight"],
  },
  {
    id: 4,
    title: "Countries Around the World",
    description:
      "A full-stack web application that allows users to hover over a map of countries and view information about them by pulling data using the WorldBank API.",
    longDescription:
      "This interactive application provides economic, social, and geographical data about countries through an intuitive map interface. Users can compare statistics and view historical trends.",
    image: "/assets/CATWproject.gif",
    categories: ["web", "data"],
    liveLink: "https://pktaz.github.io/Countries-of-The-World/",
    githubLink: "https://github.com/PkTaz/Countries-of-The-World",
    technologies: ["TypeScript", "Angular", "WorldBank API", "CSS"],
  },
];

export function projectsWithPublicUrls() {
  return portfolioProjects.map((p) => ({
    ...p,
    image: `${process.env.PUBLIC_URL}${p.image}`,
  }));
}
